import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { modalAnimations } from '@shared/animations/animations';

@Component({
    selector: 'app-mobile-code-modal',
    templateUrl: './mobile-code-modal.component.html',
    styleUrls: [],
    animations: modalAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class MobileCodeModalComponent {
    @Input() modalTitle: string;
    @Input() content: string;
    @Input() icon: string;
    @Input() closeButton: string;
    @Input() codeMobile: string;
    @Input() buttonRight = 'documentselectiontype.modal.sms.resend';
    @Input() buttonLeft = 'global.close';
    @Input() visibility: boolean;
    @Input() loading: boolean;

    @Output() visibilityChange = new EventEmitter<boolean>();
    @Output() buttonClicked = new EventEmitter<boolean>();
    @Output() leftClick = new EventEmitter<boolean>();
    @Output() rightClick = new EventEmitter<boolean>();
    @Output() crossClick = new EventEmitter<boolean>();

    close() {
        this.visibility = false;
        this.visibilityChange.emit(this.visibility);
        this.buttonClicked.emit(true);
    }
    buttonCrossClick() {
        this.crossClick.emit(true);
    }
    buttonLeftClick() {
        this.leftClick.emit(true);
    }
    buttonRightClick() {
        this.rightClick.emit(true);
    }
}
